//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import {
  IModalInstanceService,
  IModalService,
  IModalSettings,
} from 'angular-ui-bootstrap';

import getAngularInjector from '@react-bridge/getAngularInjector';

const ANGULAR_MODAL_SERVICE_NAME = '$modal';

export function openAngularModal(
  options: IModalSettings,
): IModalInstanceService {
  const angularModalService: IModalService = getAngularInjector().get(
    ANGULAR_MODAL_SERVICE_NAME,
  );
  return angularModalService.open(options);
}
